// ============================================================
// SMART CARD LAYOUT ENGINE — StatusBadge (genérico)
// ============================================================
// Badge visual genérico: label + tone. NO conoce estados de negocio
// (Vendido, En gestión…) — el consumidor mapea sus estados a tones.
// ============================================================
import React from 'react';

export type BadgeTone = 'purple' | 'green' | 'yellow' | 'gray' | 'blue';

const TONES: Record<BadgeTone, string> = {
  purple: 'bg-purple-700 text-white',
  green: 'bg-green-700 text-white',
  yellow: 'bg-yellow-600 text-white',
  gray: 'bg-gray-300 text-gray-500',
  blue: 'bg-blue-600 text-white',
};

interface StatusBadgeProps {
  label: string;
  tone?: BadgeTone;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ label, tone = 'gray', className = '' }) => (
  <span className={`px-3 py-1 rounded-full text-sm font-medium ${TONES[tone]} ${className}`}>
    {label}
  </span>
);

export default StatusBadge;
